import React, { useEffect, useMemo, useState } from 'react';
import { Typography } from '@mui/material';
import InputsService from '@api/Inputs/InputCtrl';
import { Input } from '@api/Inputs/Input';
import { showAlertError } from '@utils/Alerts/Error';
interface InputQuantityProps {
    inputId: string;
    quantity: number;
}
const InputQuantity: React.FunctionComponent<InputQuantityProps> = (props) => {
    const { inputId, quantity } = props;
    const inputsService = useMemo(() => new InputsService(), []);
    const [input, setInput] = useState<Input | undefined>(undefined);

    const getInputData = async () => {
        try {
            const inputData = await inputsService.getInput(inputId);
            setInput(inputData);
        } catch (error) {
            showAlertError(error);
        }
    };

    useEffect(() => {
        void getInputData();
    }, []);

    return <Typography>{`${quantity} ${input?.unit.unit || 'Sin unidad'}`}</Typography>;
};

export default InputQuantity;
